import StringUtils from '../Utils/StringUtils'

export default function install (Vue) {
  Object.defineProperties(Vue.prototype, {
    '$stringUtils': {
      get () {
        return StringUtils
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/StringUtils.js